import { useState } from "react";
import axios from "axios";
import { Bell } from "lucide-react";
import { useStore } from "../context/StoreContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Newsletter = () => {
  const { t, lang } = useStore();
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [status, setStatus] = useState("idle");
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) { setStatus("error"); setMsg(t.newsletter.invalid); return; }
    setStatus("sending");
    try {
      const r = await axios.post(`${API}/newsletter`, { email, lang, website });
      setStatus("done");
      setMsg(r.data.already ? t.newsletter.already : t.newsletter.thanks);
      setEmail("");
    } catch {
      setStatus("error");
      setMsg(t.newsletter.error);
    }
  };

  return (
    <section id="newsletter" className="border-t border-[var(--line)]" data-testid="newsletter-section">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-6 px-4 py-14 sm:px-6 lg:grid-cols-2 lg:gap-12 lg:py-16">
        <div>
          <p className="accent-text mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em]"><Bell className="h-4 w-4" /> Newsletter</p>
          <h2 className="font-display text-3xl sm:text-4xl" data-testid="newsletter-title">{t.newsletter.title}</h2>
          <p className="mt-2 max-w-md text-sm text-[var(--muted)] sm:text-base">{t.newsletter.sub}</p>
        </div>
        <form onSubmit={submit} className="w-full" data-testid="newsletter-form" noValidate>
          <div className="flex flex-col gap-2 sm:flex-row">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.newsletter.placeholder}
              className="field flex-1 px-4 py-3 text-sm"
              autoComplete="email"
              aria-label={t.newsletter.placeholder}
              data-testid="newsletter-email"
            />
            <input type="text" name="website" value={website} onChange={(e) => setWebsite(e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
            <button type="submit" disabled={status === "sending"} className="btn-accent px-6 py-3 text-sm" data-testid="newsletter-submit">
              {status === "sending" ? t.newsletter.sending : t.newsletter.cta}
            </button>
          </div>
          <p className={`mt-2 text-xs ${msg ? (status === "error" ? "text-red-600" : "text-green-700") : "text-[var(--muted)]"}`} data-testid="newsletter-status" role="status">
            {msg || t.newsletter.privacy}
          </p>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
